
import * as THREE from 'three';
// 直線 傾き 切片
export type straightLine = {tilt: number,slice: number}

export class Line2 {

    constructor() {
        ;
    }

    // 垂直二等分線
    static perpendicularBisector(p1: THREE.Vector2, p2: THREE.Vector2): straightLine {
        // 中点
        const middlePoint = p1.clone().add(p2).multiplyScalar(0.5);
        // 傾き　
        const sub = p2.clone().sub(p1);
        const tilt = - sub.x / sub.y;
        // 直線を算出 切片を求める middlePoint.y = tilt * middlePoint.x + slice;
        const slice = middlePoint.y - (tilt * middlePoint.x); // y = tilt * x + slice

        return {tilt: tilt, slice: slice};
    }

    // 直線と直線の交点
    static straightIntersection(line1: straightLine, line2: straightLine): THREE.Vector2 {
        // 傾きが等しい時、交点は存在しない
        if (line1.tilt == line2.tilt) return null;
        const x = (line2.slice - line1.slice) / (line1.tilt - line2.tilt);
        const y = (line1.tilt * line2.slice - line1.slice * line2.tilt) / (line1.tilt - line2.tilt);

        return new THREE.Vector2(x, y);
    }
    
    // 直線と線分の交点
    static intersection_(straightLine: straightLine, line: THREE.Line3): THREE.Vector2 {
        const p1 = line.start;
        const p2 = line.end;
        const tilt_ = (p2.y - p1.y) / (p2.x - p1.x);
        const slice_ = p1.y - (p1.x * tilt_);
        const straightLine_: straightLine = {tilt: tilt_, slice: slice_};
        // 交点
        const i = Line2.straightIntersection(straightLine, straightLine_);
        if (i == null) return null;

        // 線分の範囲内かどうか
        const minX = p1.x < p2.x ? p1.x : p2.x;
        const maxX = p1.x < p2.x ? p2.x : p1.x;
        const minY = p1.y < p2.y ? p1.y : p2.y;
        const maxY = p1.y < p2.y ? p2.y : p1.y;
        if ((minX <= i.x && i.x <= maxX) && (minY <= i.y && i.y <= maxY)) return i;
        else return null;
    }

    // 線分と線分の交点
    static lineIntersection(line1: THREE.Line3, line2: THREE.Line3): THREE.Vector2 {
        const e: number = 0.01;
        
        const s1 = ((line1.end.x - line1.start.x) * (line2.start.y - line1.start.y) - (line1.end.y - line1.start.y) * (line2.start.x - line1.start.x)) * 0.5;
        const s2 = ((line1.end.x - line1.start.x) * (line1.start.y - line2.end.y) - (line1.end.y - line1.start.y) * (line1.start.x - line2.end.x)) * 0.5;
        const t = s1 / (s1 + s2);

        if (t + e < 0 || t - e > 1) return null; 

        const x = line2.start.x + (line2.end.x - line2.start.x) * t;
        const y = line2.start.y + (line2.end.y - line2.start.y) * t;

        return new THREE.Vector2(x, y);
    }

    // 線分と線分の交差判定
    static judgeIentersected = (ax, ay, bx, by, cx, cy, dx, dy) => {
        const ta = (cx - dx) * (ay - cy) + (cy - dy) * (cx - ax);
        const tb = (cx - dx) * (by - cy) + (cy - dy) * (cx - bx);
        const tc = (ax - bx) * (cy - ay) + (ay - by) * (ax - cx);
        const td = (ax - bx) * (dy - ay) + (ay - by) * (ax - dx);
      
        // return tc * td < 0 && ta * tb < 0;
        return tc * td <= 0 && ta * tb <= 0; // 端点を含む場合
      };

}